import { useQuery } from '@tanstack/react-query'
import client from './client'

export function useVolumes(mangaId) {
  return useQuery({
    queryKey: ['volumes', mangaId],
    queryFn: () => client.get(`/api/manga/${mangaId}/volumes`).then((r) => r.data?.items ?? r.data),
    enabled: !!mangaId,
  })
}

export function useVolumeChapters(mangaId, volumeId) {
  return useQuery({
    queryKey: ['chapters', mangaId, volumeId],
    queryFn: () => client.get(`/api/manga/${mangaId}/volumes/${volumeId}/chapters`).then((r) => r.data?.items ?? r.data),
    enabled: !!(mangaId && volumeId),
  })
}

export function useAllChapters(slug) {
  const { data: volumes = [], isLoading: loadingVolumes } = useVolumes(slug)
  const { data: chapters = [], isLoading: loadingChapters } = useQuery({
    queryKey: ['all-chapters', slug],
    queryFn: () => client.get(`/api/manga/${slug}/chapters`).then((r) => r.data),
    enabled: !!slug,
  })

  return {
    data: [...chapters].sort((a, b) => a.number - b.number),
    volumes,
    isLoading: loadingVolumes || loadingChapters,
  }
}

export function useChapterPages(slug, chapterNumber) {
  return useQuery({
    queryKey: ['pages', slug, chapterNumber],
    queryFn: () =>
      client
        .get(`/api/manga/${slug}/chapter/${chapterNumber}/pages`)
        .then((r) => r.data?.items ?? r.data),
    enabled: !!(slug && chapterNumber),
    retry: false,
  })
}
